<template>
	<div class="calendar-plug" ref="calendar">

		<div class="top">
			<div>
				<van-icon name="arrow-left" class="arrow-icon" @click="lastMonthClick" />
			</div>
			<div class="date-wrap" @click="showCalendarDialog">
				<span class="date">{{ selectedYear }}年{{ selectedMonth > 9 ? selectedMonth : '0' + selectedMonth }}月</span>
				<!-- <span class="month-count" v-if="monthMeetingsCount > 0">{{ monthMeetingsCount }} 场会议</span> -->
			</div>
			<div>
				<van-icon name="arrow" class="arrow-icon" @click="nextMonthClick" />
			</div>
			<div class="search">
				<img src="@/assets/images/icon_search.png" @click="goSearch" />
			</div>
		</div>
		<div class="container">
			<div class="everyDay">
				<div class="weekDay">
					<van-row type="flex" justify="space-between">
						<van-col span="3" v-for="(item, index) in weekDays" :key="index" :class="index >= 5 ? 'weekend' : ''">{{ item }}</van-col>
					</van-row>
				</div>
				<div v-for="(value, week_index) in groupByWeekArr" :key="week_index" class="every-week">
					<van-row type="flex" justify="space-between" class="day-number">
						<van-col span="3" v-for="(item, index) in value.number" :key="index" class="day-col"
							:class="[
								!item ? 'empty-day' : '',
								item == currentDay && selectedMonth == currentMonth && selectedYear == currentYear ? 'today-number' : '',
								item == selectedDay.day && selectedMonth == selectedDay.month && selectedYear == selectedDay.year ? 'choose-day' : ''
							]"
							@click="item && selectDate(item)">
							<span class="day-num">{{ item }}</span>
						</van-col>
					</van-row>
					<van-row type="flex" justify="space-between" class="every-meeting"
						v-for="(meeting, index) in meetingsByWeek" :key="index">
						<van-col v-if="meeting.week_number == week_index" :span="Math.round(meeting.offset)"></van-col>
						<van-col v-if="meeting.week_number == week_index" :span="Math.round(meeting.day_count)"
							:style="{ background: backgroundColor[meeting.color_index % 5], 'border-radius': '5px' }"
							class="line-1" @click.stop="showDetail(meeting.color_index)">
							<!-- {{ meeting.title }} -->
						</van-col>
						<van-col v-if="meeting.week_number == week_index"
							:span="24 - Math.round(meeting.offset) - Math.round(meeting.day_count)"></van-col>
					</van-row>
				</div>
			</div>
		</div>
		<van-popup v-model="show" position="bottom" round closeable>
			<h2>会议</h2>
			<div class="detail-item" @click="goDetail(detailInfo)">
				<span class="color-line" :style="{ 'background-color': backgroundColor[color_index] }"></span>
				<div class="content">
					<div class="name">{{ detailInfo.name }}</div>
					<div>
						<p v-if="detailInfo.city">地点：{{ detailInfo.province + " " + detailInfo.city }}
						</p>
						<p v-else>地点：{{ detailInfo.province }}</p>
						<p>{{ detailInfo.start_at }}-{{ detailInfo.end_at }}</p>
					</div>

				</div>
				<div class="image">
					<img :src="detailInfo.banner" />
				</div>
			</div>
		</van-popup>
		<van-popup v-model="chooseDateFlag" position="bottom" round>
			<van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :formatter="formatter"
				@confirm="confirmDate" @cancel="chooseDateFlag = false" />
		</van-popup>
	</div>
</template>
<script>
export default {
	props: {
		monthMeetingsCount: { type: Number, default: 0 }
	},
	data() {
		return {
			calendar_active: 1,
			currentYear: new Date().getFullYear(),      //当前年
			currentMonth: new Date().getMonth() + 1,        //当前月
			currentDay: new Date().getDate(),           //代表今天
			currentWeekday: new Date().getDay(),       //今天周几
			currentDate: new Date(),
			defaultWeekday: '',                        //每个月1号对应的周几
			dayCount: 0,            //这个月的天数
			// weekdayCount:0,        //这个周有几天
			lastMonthDay: 0,
			weekDays: ["一", "二", "三", "四", "五", "六", "日"],
			months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
			lastDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			selectedYear: '',      //选中的年份
			selectedMonth: '',     //选中的月份
			selectedDay: {},       //选中的日期
			dateArr: [],
			monthMeetings: [],      //本月会议
			monthMeetingsDate: [],       //本月会议日期
			backgroundColor: ['#4B85ED', '#FDA245', '#57C393', '#FF8288', '#C783FC'],
			bgColor: ['#ECF3FF', '#FFF4EA', '#DDF6EB', '#FFEDEE', '#F8EEFF'],
			groupByWeekArr: [], //本月日期 一周一组
			meetingsByWeek: [],
			show: false,
			detailInfo: {},
			color_index: 0,
			chooseDateFlag: false
		}
	},

	mounted() {
		this.selectedYear = this.currentYear;
		this.selectedMonth = this.currentMonth;
		this.selectedDay = {
			year: this.currentYear,
			month: this.currentMonth,
			day: this.currentDay
		}
		this.getThisMonthDay(this.selectedYear, this.selectedMonth);
		this.getThisWeekDay(this.selectedYear, this.selectedMonth, 1);
	},
	methods: {
		//初始化
		init(data) {
			this.monthMeetingsDate = [];
			this.monthMeetings = data;
			let length = 0;
			for (let j = 0; j < data.length; j++) {
				let str1 = data[j].start_at;
				let str2 = data[j].end_at;
				let arr1 = this.dataScope(str1, str2);
				let arr2 = {
					name: data[j].calendar_title,
					date: [],
					id: data[j].id,
					buttons_count: data[j].buttons_count
				};
				for (let j = 0; j < arr1.length; j++) {
					let dateArr = arr1[j].split('-');
					let date = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
					if (this.selectedMonth == date.getMonth() + 1 && this.selectedYear == date.getFullYear()) {
						arr2.date.push(date.getDate())
					}
				}
				this.monthMeetingsDate.push(arr2);

			}

			this.monthMeetingsDate.sort(function (a, b) {
				return b.date.length - a.date.length;
			})
			this.groupByWeek();
			this.meetingGroupByWeek();
		},
		//时间段内对应的日期
		dataScope(value1, value2) {
			var date1 = new Date(value1).getTime();
			var date2 = new Date(value2).getTime();
			if (date1 > date2) {
				var tempDate = date1;
				date1 = date2;
				date2 = tempDate;
			}
			var dateArr = [];
			var i = 0;

			while (date1 <= date2) {
				date1 = new Date(date1);
				var dayStr = date1.getDate().toString();
				if (dayStr.length == 1) {
					dayStr = "0" + dayStr;
				}
				dateArr[i] = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-"
					+ dayStr;
				i++;

				date1.setDate(date1.getDate() + 1);
			}
			return dateArr;
		},
		//选择日期
		selectDate(day) {
			this.selectedDay = {
				year: this.selectedYear,
				month: this.selectedMonth,
				day: day
			}
			let date = this.selectedDay
			date.month = date.month < 10 ? '0' + date.month : date.month;
			date.day = date.day < 10 ? '0' + date.day : date.day;
			this.$emit('changeDay', date.year + '-' + date.month + '-' + date.day)
		},
		//判断是否是闰年
		isLeapYear: function (year) {
			if (0 == year % 4 && ((year % 100 != 0) || (year % 400 == 0))) {
				return true
			}
			return false;
		},
		//得到这个月的天数
		getThisMonthDay: function (year, month) {
			var dayCount = this.lastDays[month - 1];
			this.lastMonthDay = this.lastDays[month - 2];       //上个月的天数
			if ((month == 2) && this.isLeapYear(year)) {
				dayCount++;
			}
			this.dayCount = dayCount;
			let dateArr = [];
			for (let i = 1; i <= dayCount; i++) {
				let obj = {};
				obj.solar = i;
				obj.month = month;
				obj.year = year;
				dateArr.push(obj);
			}
			this.dateArr = dateArr;
		},
		//得到上个月的天数
		getLastMonthDay(year, month) {
			var dayCount = this.lastDays[month - 2];
			this.lastMonthDay = dayCount;
		},
		//得到周几(一般得到每个月1号是周几)
		getThisWeekDay: function (year, month, date) {
			var thisDate = new Date(year, month - 1, date - 1);
			this.defaultWeekday = thisDate.getDay();
		},
		//切换上个月
		lastMonthClick() {
			this.calendar_active = 0;
			this.monthMeetingsDate = [];    //将数据清空  以防数据变动  出现闪
			if (this.selectedMonth == 1) {
				this.selectedYear--;
				this.selectedMonth = 12;
			} else {
				this.selectedMonth--;
			}
			this.reloadData();
		},
		//切换下一个月
		nextMonthClick() {
			this.calendar_active = 1;
			this.monthMeetingsDate = [];   //将数据清空  以防数据变动  出现闪
			if (this.selectedMonth == 12) {
				this.selectedYear++;
				this.selectedMonth = 1;
			} else {
				this.selectedMonth++;
			}
			this.reloadData();
		},

		//重新刷新数据
		reloadData() {
			this.getThisMonthDay(this.selectedYear, this.selectedMonth);
			this.getThisWeekDay(this.selectedYear, this.selectedMonth, 1);
			this.$emit('changeMonth', this.selectedMonth, this.selectedYear)
		},
		cumWeekDayCounrt: function (date) {
			var thisDate = new Date(this.selectedYear, this.selectedMonth - 1, date);
			return thisDate.getDay();
		},
		//按周分日期
		groupByWeek() {
			let first = { number: [] };
			if (this.defaultWeekday > 0) {
				for (let i = 0; i < this.defaultWeekday; i++) {
					first.number.push('')
				}
			}
			if (7 - this.defaultWeekday > 0) {
				for (let i = 1; i <= 7 - this.defaultWeekday; i++) {
					first.number.push(i)
				}
			}
			this.groupByWeekArr = [];
			this.groupByWeekArr.push(first);
			let lastDay = 0;
			for (let i = 0; i < (this.dayCount - (7 - this.defaultWeekday)) / 7 - 1; i++) {
				let week = { number: [] };
				for (let j = 0; j < 7; j++) {
					week.number.push(7 - this.defaultWeekday + i * 7 + j + 1);
				}
				lastDay = 7 - this.defaultWeekday + i * 7 + 7;
				this.groupByWeekArr.push(week);
			}
			if (this.dayCount - lastDay > 0) {
				let week = { number: [] }
				for (let i = lastDay + 1; i < this.dayCount + 1; i++) {
					week.number.push(i);
				}
				for (let i = 0; i < 7 - (this.dayCount - lastDay); i++) {
					week.number.push('');
				}
				this.groupByWeekArr.push(week);
			}
		},
		//显示弹框跳出详情
		showDetail(index) {
			this.show = true
			let obj = this.monthMeetings[index]
			obj['start_at'] = obj.start_at.split('-').join('.')
			obj['end_at'] = obj.end_at.split('-').join('.').substring(5)

			this.detailInfo = obj
			// this.$set(this.detailInfo,this.monthMeetings[index])
			this.color_index = index
		},
		//跳转
		goDetail(val) {
			let id = val.id
			let buttons_count = val.buttons_count
            if(val.live_url){
                window.location.href = val.live_url
                return;
            }
			if (id == 286) {
				this.$router.push({
					path: '/CEC2022/index',
				})
				return
			}
			else if (id == 348) {
				this.$router.push({
					path: '/CEC2023/index',
				})
				return
			}
			else if (id == 399) {
				this.$router.push({
					path: '/CVSCF2023/index'
				})
				return
			}
			else if (id == 483) {
				this.$router.push({
					path: '/XVC/index'
				})
				return
			}
			if (buttons_count) {
				this.$router.push({
					path: '/vascularNews/meeting/index',
					query: {
						meeting_id: id,
					}
				})
			}
			else {
				this.$router.push({
					path: '/vascularNews/meeting/live',
					query: {
						meeting_id: id,
					}
				})
			}

		},
		//按周分会议
		meetingGroupByWeek() {
			//判断是这个月第几个星期的 推到groupByWeekArr这个数组中
			let meetingsWeek = [];
			this.monthMeetingsDate.forEach((item, index) => {
				let week_number = parseInt((item.date[0] + this.defaultWeekday - 1) / 7); //第一行在第几个礼拜显示
				let color_index = index;
				for (let i = 0; i < this.monthMeetings.length; i++) {
					if (item.id == this.monthMeetings[i].id) {
						color_index = i;
						break;
					}
				}
				//设置颜色index  偏移数量 天数数量
				//如果不止一个礼拜有
				if ((item.date[0] + this.defaultWeekday - 1) % 7 + item.date.length > 7) {
					let week_count = parseInt((((item.date[0] + this.defaultWeekday - 1) % 7 + item.date.length) - 1) / 7 + 1);
					if (week_count == 2) {
						let dict = {
							week_number: week_number,
							color_index: color_index,
							offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
							day_count: 7 - (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
							title: item.name,
							id: item.id,
							buttons_count: item.buttons_count
						}
						meetingsWeek.push(dict);
						dict = {
							week_number: week_number + 1,
							color_index: color_index,
							offset: 0,
							day_count: (item.date.length - (7 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
							title: item.name,
							id: item.id,
							buttons_count: item.buttons_count
						}
						meetingsWeek.push(dict)
					}
					else {
						if (week_count == 3) {
							let dict = {
								week_number: week_number,
								color_index: color_index,
								offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
								day_count: 7 - (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}


							meetingsWeek.push(dict);
							dict = {
								week_number: week_number + 1,
								color_index: color_index,
								offset: 0,
								day_count: 7 * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}
							meetingsWeek.push(dict)
							dict = {
								week_number: week_number + 2,
								color_index: color_index,
								offset: 0,
								day_count: (item.date.length - (14 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}
							meetingsWeek.push(dict)
						}
						else {
							if (week_count == 4) {
								let dict = {
									week_number: week_number,
									color_index: color_index,
									offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
									day_count: (7 - (item.date[0] - 1 + this.defaultWeekday) % 7) * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict);
								dict = {
									week_number: week_number + 1,
									color_index: color_index,
									offset: 0,
									day_count: 7 * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
								dict = {
									week_number: week_number + 2,
									color_index: color_index,
									offset: 0,
									day_count: 7 * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
								dict = {
									week_number: week_number + 3,
									color_index: color_index,
									offset: 0,
									day_count: (item.date.length - (21 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
							}

						}
					}
				}
				//如果是一个礼拜中的
				else {
					let dict = {
						week_number: week_number,
						color_index: color_index,
						offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
						day_count: item.date.length * 3.4,
						title: item.name,
						id: item.id,
						buttons_count: item.buttons_count
					}
					meetingsWeek.push(dict)
				}
			})
			this.meetingsByWeek = meetingsWeek;
			// console.log(this.meetingsByWeek)
		},
		showCalendarDialog() {
			this.chooseDateFlag = true
		},
		formatter(type, val) {
			if (type === 'year') {
				return `${val}年`;
			} else if (type === 'month') {
				return `${val}月`;
			}
			return val;
		},
		confirmDate(value) {
			this.chooseDateFlag = false;
			if (this.selectedYear != value.getFullYear() || this.selectedMonth != (value.getMonth() + 1)) {
				this.monthMeetingsDate = [];   //将数据清空  以防数据变动  出现闪
				this.selectedYear = value.getFullYear();
				this.selectedMonth = value.getMonth() + 1
				this.reloadData();
			}
		},
		goSearch() {
			// if(this.keywords){
			this.$router.push({
				path: '/vascularNews/search',
				query: {
					keywords: this.keywords
				}
			})
			// }
		}

	}
}
</script>
<style lang="scss" scoped>
.calendar-plug {
	background: #ffffff;
	padding: 0 15px 16px;
	border-radius: 16px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);

	.top {
		padding: 14px 0 10px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		position: relative;

		img {
			width: 20px;
			height: 20px;
		}

		.arrow-icon {
			font-size: 14px;
			border-radius: 50%;
			width: 26px;
			height: 26px;
			line-height: 26px;
			text-align: center;
			background: #e8f0fe !important;
			color: #1a73e8 !important;
		}

		.date-wrap {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0 20px;
			cursor: pointer;
		}

		.date {
			color: #141414;
			font-size: 16px;
			font-weight: 600;
			line-height: 22px;
		}

		.month-count {
			font-size: 12px;
			color: #5f6368;
			margin-top: 2px;
		}
	}

	.search {
		position: absolute;
		width: 26px;
		height: 26px;
		text-align: center;
		line-height: 26px;
		border-radius: 50%;
		right: 0;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.container {
		margin: 0 -4px;

		.everyDay {
			.weekDay {
				text-align: center;
				font-size: 14px;
				color: #5f6368;
				padding: 10px 0 8px;

				.weekend {
					color: #ff4d4f;
				}
			}

			.every-week {
				text-align: center;
				padding:1px 0;
			}

			.day-col {
				display: flex;
				align-items: center;
				justify-content: center;
				min-height: 28px;
			}

			.day-num {
				font-size: 15px;
				color: #3c4043;
				font-weight: 500;
			}

			.empty-day .day-num {
				color: #dadce0;
			}

			.today-number .day-num {
				color:  #901d22;
				font-weight: 600;
			}

			.choose-day .day-num {
				color:#1a73e8 ;
				font-weight: 600;
			}

			// .choose-day {
			// 	background: #e8f0fe;
			// 	border: 1px solid #1a73e8;
			// 	border-radius: 8px;
			// }

			.every-meeting {
				font-size: 13px;
				color: #ffffff;
				line-height: 22px;

				.line-1 {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					margin-bottom: 5px;
					padding: 3px 5px;
					flex: 1;
				}
			}
		}
	}
}

h2 {
	font-size: 15px;
	text-align: center;
	line-height: 54px;
	color: #141414;
	font-weight: 500;
}

.detail-item {
	display: flex;
	margin: 10px 15px 24px;

	.color-line {
		background: #4b85ed;
		width: 5px;
		display: inline-block;
		border-radius: 2.5px;
		margin-right: 12px;
	}

	img {
		width: 100%;
		border-radius: 8px;
		object-fit: cover;
	}

	.image {
		width: 34%;
		margin-left: 4%;
	}

	.content {
		width: 62%;
		position: relative;
		font-size: 14px;
		padding: 4px 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		min-height: 90px;

		p {
			font-size: 12px;
			line-height: 16px;
			color: #666666;
		}
	}
}

@media screen and (min-width: 1000px) {
	h2 {
		line-height: 40px;
	}

	.detail-item {
		margin: 10px 20px 20px;

		.image {
			width: 22%;
			margin-left: 4%;
		}

		.content {
			width: 70%;

			p {
				margin-bottom: 4px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Calendar.vue